import { initSTPayment } from "./src";
export default initSTPayment